import RecordHelper from "@/bussiness/RecordHelper";
import Button from "@/component/Button";
import SelectionList from "@/component/SelectionList";
import { speakerNameLimitPattern } from "@/constants/record";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import recordStore from "@/store/record.store";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import Popover from "@/component/PopoverRc";
import { ReactNode, useMemo, useState } from "react";
import MoreIcon from "@/assets/summary/more.svg?react";
import fridayReporter from "@/utils/friday";
import InputWithClear from "@/component/InputWithClear";

export interface ISpeakerPopoverProps {
  onEditSingle: (name: string) => void;
  onEditAll?: (name: string, oldSpeakerName: string) => void;
  originValue: string;
}

const SpeakerPopover: React.FC<ISpeakerPopoverProps> = ({ onEditAll, onEditSingle, originValue }) => {
  // 赶时间，先抄过来改改，直接引用了
  const speakerList = recordStore((state) => state.recentSpeakerList);

  const [inputValue, setInputValue] = useState<string>('');

  const editDisabled = useMemo(() => !inputValue || inputValue === originValue, [inputValue, originValue]);

  const list = useMemo(() => {
    // 如果value在speakerList中，就把value放在第一个
    const targetValue = inputValue || originValue;
    const speakerNamesList = speakerList.map((item) => item.speakerName[0]);

    const element = speakerList.find((item) => item.speakerName[0] === targetValue);
    if (element && speakerNamesList.includes(targetValue)) {
      return [element, ...speakerList.filter((item) => item.speakerName[0] !== targetValue)];
    }
    return speakerList;
  }, [speakerList, inputValue, originValue]);

  const handleEditSingle = () => {
    if (editDisabled) return;
    onEditSingle(inputValue);
  };

  const handleEditAll = () => {
    if (editDisabled) return;
    onEditAll?.(inputValue, originValue);
  };

  const handleSelectRole = (val: string) => {
    setInputValue(val.trim());
  };

  const options = useMemo(() => {
    return [
      {
        id: "DELETE",
        label: "删除",
      },
    ];
  }, []);

  const handlSelectOptions = (item: { id: string; label: ReactNode }, name: string) => {
    if (item.id === "DELETE") {
      fridayReporter.pushData({
        eventCode: 'SummaryPage_Text_EditSpeaker_Delete'
      })
      RecordHelper.deleteSpeakerName([name]);
    }
  };

  const handleInputChange = (value: string) => {
    setInputValue(value);
  }

  return (
    <div className="w-60 p-2 pb-0">
      <InputWithClear
        autoFocus
        className="
          w-full h-8 block p-2 outline-none
          b-1 b-solid b-mx-quaternary rounded-2.5
          text-3.5 text-mx-secondary font-400
        shadow-[0_0_8px_0_rgba(73,129,242,0.24)];
        placeholder:text-mx-quaternary
        focus:b-mx-primary
        "
        wapperClassName="w-full"
        allowClear={false}
        limitPattern={speakerNameLimitPattern}
        placeholder="请输入名字"
        onMyChange={handleInputChange}
        maxLength={10}
        value={inputValue}
      />
      {list.length > 0 && (
        <div className="h-50 overflow-y-hidden px-1.5 py-2 flex flex-col">
          <div className="text-mx-tertiary text-3.5 mt-2.5 ml-2 mb-1.5 text-left">建议</div>
          <div className="overflow-auto flex-1">
            {list.map((item) => {
              const speakerAvatarInfo = getSpeakerAvatarInfo(item.headImage);
              const name = item.speakerName[0];
              return (
                <div
                  key={name}
                  onClick={() => {
                    handleSelectRole(name);
                  }}
                  className={`w-full flex flex-row items-center justify-between cursor-pointer hover:bg-#F4F6F9 px-1 py-1 my-1 rounded-2.5 ${
                    (name === (inputValue || originValue)) && "bg-[rgba(25,29,38,0.05)]"
                  }`}
                >
                  <div className="flex items-center">
                    <SpeakerAvatar
                      speakerName={name}
                      avatarIndex={speakerAvatarInfo.avatarIndex}
                      useDefaultAvatarIcon={item.useDefaultIcon}
                      className="size-8 mr-2 rounded-full"
                    />
                    <div className="flex-1 text-3.5 text-mx-secondary max-w-32 mx-text-ellipsis" title={name}>
                      {name}
                    </div>
                  </div>
                  <Popover
                    placement="topRight"
                    align={{ offset: [10, 0] }}
                    content={
                      <SelectionList
                        options={options}
                        onSelect={(option) => {
                          handlSelectOptions(option, name);
                        }}
                        stopPropagation
                      />
                    }
                  >
                    <div
                      className="more-icon size-6 ml-1 mr-2 flex items-center justify-center hover:bg-#ECEEF3 rounded-2"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <MoreIcon className="size-4" />
                    </div>
                  </Popover>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="h-12 w-full sticky bottom-0 px-2">
        <div className="b-t-1 b-t-solid b-t-#eceef3 h-full w-full flex flex-row justify-end items-center gap-2">
          <Button disabled={editDisabled || !inputValue.trim().length} className="h-8 text-3 text-mx-tertiary flex items-center rounded-2.5" onClick={handleEditAll}>
            全局修改
          </Button>
          <Button type="primary" disabled={editDisabled || !inputValue.trim().length} className="h-8 text-3 flex items-center rounded-2.5" onClick={handleEditSingle}>
            单处修改
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SpeakerPopover;
